// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"notification_messageWrapper__106Jq","messageBody":"notification_messageBody__1x_9y"};